import { NgModule } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";

import { PipesModule } from "../../shared/pipes/pipes.module";
import { TranslateModule } from "@ngx-translate/core";
import { LayoutModule } from "@onsip/web/features/shared/components/layout/layout.module";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatStepperModule } from "@angular/material/stepper";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatTabsModule } from "@angular/material/tabs";

import { OnsipFormsModule } from "../../shared/components/forms/onsip-forms.module";

import { AdvAnnouncementsPageComponent } from "./announcementsPage/adv-announcements-page.component";
import { AdvAnnouncementsRecordingTabComponent } from "@onsip/web/features/administrators/announcements/announcementsShelfContainer/announcementsRecording/adv-announcements-recording-tab.component";
import { AdvAnnouncementsBasicEditComponent } from "@onsip/web/features/administrators/announcements/announcementsShelfContainer/announcementsBasic/announcementsBasicEdit/adv-announcements-basic-edit.component";
import { AdvAnnouncementsSetupComponent } from "@onsip/web/features/administrators/announcements/announcementsSetup/adv-announcements-setup.component";
import { AdvAnnouncementsBasicTabComponent } from "@onsip/web/features/administrators/announcements/announcementsShelfContainer/announcementsBasic/adv-announcements-basic-tab.component";
import { AdvAnnouncementsShelfComponent } from "@onsip/web/features/administrators/announcements/announcementsShelfContainer/adv-announcements-shelf-container.component";
import { AdvAnnouncementsRecordingViewComponent } from "@onsip/web/features/administrators/announcements/announcementsShelfContainer/announcementsRecording/announcementsRecordingView/adv-announcements-recording-view.component";
import { AdvAnnouncementsBasicViewComponent } from "@onsip/web/features/administrators/announcements/announcementsShelfContainer/announcementsBasic/announcementsBasicView/adv-announcements-basic-view.component";
import { AdvAnnouncementsRecordingEditComponent } from "@onsip/web/features/administrators/announcements/announcementsShelfContainer/announcementsRecording/announcementsRecordingEdit/adv-announcements-recording-edit.component";
import { AnnouncementsRoutingModule } from "@onsip/web/features/administrators/announcements/announcements-routing.module";
import { TableModule } from "@onsip/web/features/shared/components/table/onsip-table.module";
import { MatDialogModule } from "@angular/material/dialog";

import { EditItemListModule } from "@onsip/web/features/shared/components/onsipItemList/edit-item-list.module";
import { SelectionListDeluxeModule } from "@onsip/web/features/shared/components/pickers/selectionListDeluxe/selection-list-deluxe.module";
import { FormEventTrackingModule } from "@onsip/web/features/shared/components/analytics/form-event-tracking.module";
import { AddressAutocompleteModule } from "@onsip/web/features/administrators/addressAutocomplete/address-autocomplete.module";
import { AudioRecorderModule } from "@onsip/web/features/shared/components/audioRecorder/audio-recorder.module";
import { ListPickerModule } from "@onsip/web/features/shared/components/pickers/listPicker/list-picker.module";
import { ExtensionsListModule } from "@onsip/web/features/shared/components/extensionsList/extensions-list.module";
import { PhoneNumberListModule } from "../../shared/components/phoneNumberList/phone-number-list.module";
import { SipAddressFieldModule } from "../../shared/components/sipAddressField/sip-address-field.module";
import { TableDataLoadContainerModule } from "../../shared/components/tableDataLoadContainer/table-data-load-container.module";
import { TogglableRecorderModule } from "../../shared/components/togglableRecorder/togglable-recorder.module";
import { AnnouncementsEmptyDataComponent } from "./announcements-empty-data/announcements-empty-data.component";
import { LoadingContainerComponent } from "../../shared/components/loadingContainer/loading-container.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    PipesModule,
    OnsipFormsModule,
    RouterModule,
    TableModule,
    EditItemListModule,
    SelectionListDeluxeModule,
    FormEventTrackingModule,
    AddressAutocompleteModule,
    AudioRecorderModule,
    ListPickerModule,
    AnnouncementsRoutingModule,
    SipAddressFieldModule,
    PhoneNumberListModule,
    ExtensionsListModule,
    TableDataLoadContainerModule,
    LayoutModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatSortModule,
    MatTableModule,
    MatPaginatorModule,
    MatStepperModule,
    MatRadioModule,
    MatSelectModule,
    MatTabsModule,
    MatDialogModule,
    TogglableRecorderModule,
    LoadingContainerComponent
  ],
  declarations: [
    AdvAnnouncementsPageComponent,
    AdvAnnouncementsBasicEditComponent,
    AdvAnnouncementsBasicViewComponent,
    AdvAnnouncementsShelfComponent,
    AdvAnnouncementsRecordingViewComponent,
    AdvAnnouncementsRecordingEditComponent,
    AdvAnnouncementsBasicTabComponent,
    AdvAnnouncementsRecordingTabComponent,
    AdvAnnouncementsSetupComponent,
    AnnouncementsEmptyDataComponent
  ],
  providers: [DatePipe]
})
export class AnnouncementsModule {}
